import {cn} from '@rocket-ui/tools';
import React from 'react';

interface PageTitleProps {
	children: React.ReactNode;
	className?: string;
}

export function PageTitle({children, className}: PageTitleProps): React.ReactElement {
	return <h1 className={cn('mb-5 text-[32px] leading-[1.1] font-medium text-[#000000]', className)}>{children}</h1>;
}
